







































import { Component, Prop, Vue } from "vue-property-decorator";

import PointNotation from "@/common/components/atoms/PointNotation.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    PointNotation
  }
})
export default class TheHDetail extends Vue {
  @Prop({ type: [String, Boolean], default: false }) image!: string | boolean;
  @Prop({ type: Boolean, default: false }) roundedImage!: boolean;
  @Prop({ type: Object, default: {} }) usagePoint: any;
  @Prop({ type: Boolean, default: true }) maxWidth!: boolean;

  get isSp() {
    return globals?.isSpScreenWidth;
  }

  get colorCode() {
    return commons?.colorCode;
  }

  get pointStyle() {
    if (this.isSp) {
      return {
        fontSize: 32,
        iconSize: 24
      };
    } else {
      return {
        fontSize: 44,
        iconSize: 32
      };
    }
  }

  get roundedClassName() {
    const { roundedImage } = this;
    const className = "p-h-detail__header__image--rounded";
    const resultClassName = roundedImage ? className : "";
    return resultClassName;
  }
}
